export default __webpack_public_path__ + "static/media/icon_close.56e7ee4e.svg";